import { api } from "@/lib/api";

function urlBase64ToUint8Array(base64String) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const raw = atob(base64);
  const out = new Uint8Array(raw.length);
  for (let i = 0; i < raw.length; i++) out[i] = raw.charCodeAt(i);
  return out;
}

export function pushSupported() {
  return "serviceWorker" in navigator && "PushManager" in window && "Notification" in window;
}

export async function registerServiceWorker() {
  if (!pushSupported()) return null;
  return await navigator.serviceWorker.register("/sw.js");
}

export async function getSubscription() {
  if (!pushSupported()) return null;
  const reg = await navigator.serviceWorker.ready;
  return await reg.pushManager.getSubscription();
}

export async function subscribeUser() {
  if (!pushSupported()) throw new Error("Push notifications not supported in this browser");
  if (Notification.permission === "denied") throw new Error("Notifications were blocked. Enable in browser settings.");
  const reg = await registerServiceWorker();
  const perm = Notification.permission === "granted"
    ? "granted"
    : await Notification.requestPermission();
  if (perm !== "granted") throw new Error("Permission denied");

  const { data } = await api.get("/push/vapid-public-key");
  const applicationServerKey = urlBase64ToUint8Array(data.public_key);
  const sub = await reg.pushManager.subscribe({ userVisibleOnly: true, applicationServerKey });
  await api.post("/push/subscribe", { subscription: sub.toJSON() });
  return sub;
}

export async function unsubscribeUser() {
  const sub = await getSubscription();
  if (!sub) return false;
  await api.post("/push/unsubscribe", { subscription: sub.toJSON() });
  await sub.unsubscribe();
  return true;
}

export async function sendTestNotification() {
  return api.post("/push/test", { title: "Cosmic Sage ✦", body: "Push notifications are working perfectly." });
}
